export default (props) => (
  /**
   * Rótulo ocultado com cor de preenchimento dinâmica.
   * Responsavel por ocultar rótulo da camada
   * importada se a mesma possuir rótulo.
   */
  <svg
    width="27"
    height="18"
    viewBox="0 0 27 21"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <circle
      cx="2.46538"
      cy="6.45308"
      r="1.5"
      transform="rotate(-171.594 2.46538 6.45308)"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <circle
      cx="9.86528"
      cy="18.4257"
      r="1.5"
      transform="rotate(-171.594 9.86528 18.4257)"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <circle
      cx="9.86526"
      cy="18.4258"
      r="0.75"
      transform="rotate(-171.594 9.86526 18.4258)"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.68251 4.45314L2.36268 5.99047L1.66404 6.1372L2.04073 6.74363L9.45953 18.6869L10.309 18.1593L3.26687 6.82239L10.527 5.2976L9.68251 4.45314Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.48537 4.2569C9.46339 4.32855 9.44655 4.40271 9.43526 4.47913C9.31416 5.29865 9.88033 6.06116 10.6998 6.18225C10.9288 6.21606 11.1534 6.19629 11.3607 6.13226L9.48537 4.2569ZM12.4184 4.64441C12.3937 3.93488 11.8659 3.32202 11.1384 3.21448C11.083 3.2063 11.028 3.20123 10.9733 3.19922L12.4184 4.64441Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.7188 10.4912V15.5817H20.415V15.1875L18.8627 13.6352V13.9323H17.2842V12.3619H17.5894L15.7188 10.4912ZM20.415 12.642V7.66406H15.7188V7.94562L17.2842 9.51111V9.23438H18.8627V10.8047H18.5778L20.415 12.642Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.3548 15.5817H26.4795V13.9323H23.3354V9.23438H26.4795V7.66406H21.7832V14.0101L23.3548 15.5817Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8916 7.66406H9.6543V15.5817H11.2197V12.3619H12.7983V15.5817H14.3637V9.13617L12.8916 7.66406ZM12.7983 9.23438V10.8047H11.2197V9.23438H12.7983Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
    <path
      d="M4.9542 2.10899C4.6265 1.78128 4.6265 1.24997 4.9542 0.922264C5.28191 0.594559 5.81322 0.594559 6.14092 0.922264L24.2667 19.0481C24.5944 19.3758 24.5944 19.9071 24.2667 20.2348C23.939 20.5625 23.4077 20.5625 23.08 20.2348L4.9542 2.10899Z"
      fill={props.fill ? props.fill : 'currentColor'}
    />
  </svg>
);
